import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=5efe4278&scoped=true&"
import script from "./Insurance.ts?vue&type=script&lang=ts&"
export * from "./Insurance.ts?vue&type=script&lang=ts&"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=5efe4278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe4278",
  null
  
)

export default component.exports